import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH DOCUMENT TO EDIT ********************
export const fetchDocument = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_DOCUMENT_LOADING,
			payload: true
		});

		const response = await services.get(`/documents/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_DOCUMENT_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_DOCUMENT_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
